/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./Toolbar.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  toolbarBase: "_2rkoi2wt _zulp1b66 _bfhkvuon _1e0c1txw _4cvr1h6o",
  toolbar: "_4t3i14no _u5f31b66 _19bv1b66 _16qs1cd0",
  primaryToolbar: "_bfhkvuon _1tkezwfg"
};
/**
 * A simple component representing a toolbar with box shadows - used to represent a secondary/floating toolbar
 */
export var Toolbar = function Toolbar(_ref) {
  var children = _ref.children,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.toolbarBase, styles.toolbar),
    role: "toolbar",
    "aria-label": label
  }, children);
};

/**
 *  A simple component representing a toolbar without box shadows - used to represent a primary toolbar
 */
export var PrimaryToolbar = function PrimaryToolbar(_ref2) {
  var children = _ref2.children,
    label = _ref2.label;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.toolbarBase, styles.primaryToolbar),
    role: "toolbar",
    "aria-label": label
  }, children);
};